module.exports = __webpack_public_path__ + "img/good22.a359abca.png";